<template>
  <b-form
    novalidate
    @submit.prevent="submit"
  >
    <validation-observer ref="formRef">
      <b-card>
        <b-row>
          <b-col md="12">
            <h3>Business Details</h3>
          </b-col>
          <b-col md="4">
            <validation-provider
              #default="{ errors }"
              name="Business Name En"
              rules="required"
            >
              <b-form-group
                label="Business Name En"
                label-for="business-name-en"
              >
                <b-form-input
                  id="business-name-en"
                  v-model="businessData.name.en"
                  placeholder="Business Name En"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="4">
            <validation-provider
              #default="{ errors }"
              name="Business Name Ar"
              rules="required"
            >
              <b-form-group
                label="Business Name Ar"
                label-for="business-name-ar"
              >
                <b-form-input
                  id="business-name-ar"
                  v-model="businessData.name.ar"
                  placeholder="Business Name Ar"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="4">
            <validation-provider
              #default="{ errors }"
              name="Business Email"
              rules="required"
            >
              <b-form-group
                label="Business Email"
                label-for="business-email"
              >
                <b-form-input
                  id="business-email"
                  v-model="businessData.email"
                  placeholder="Business Email"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="4">
            <validation-provider
              #default="{ errors }"
              name="Phone No"
              rules="required"
            >
              <b-form-group
                label="Phone No"
                label-for="phone-no"
              >
                <b-form-input
                  id="phone-no"
                  v-model="businessData.phoneNumber"
                  placeholder="Ex: +962787570753"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col
            v-if="isFoodBusinessType"
            md="8"
          />
          <b-col
            v-if="isFoodBusinessType"
            md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="Preparation average time En"
              rules="required"
            >
              <b-form-group
                label="Preparation average time En"
                label-for="Preparation-average-time-en"
              >
                <b-form-input
                  id="Preparation-average-time-en"
                  v-model="businessData.info.preparationAvgTime.en"
                  placeholder="Enter Preparation average time En"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col
            v-if="isFoodBusinessType"
            md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="Preparation average time Ar"
              rules="required"
            >
              <b-form-group
                label="Preparation average time Ar"
                label-for="Preparation-average-time-ar"
              >
                <b-form-input
                  id="Preparation-average-time-ar"
                  v-model="businessData.info.preparationAvgTime.ar"
                  placeholder="Enter Preparation average time Ar"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col
            v-if="isFoodBusinessType"
            md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="Price Rate"
              rules="required|between:1,4"
            >
              <b-form-group
                label="Price Rate"
                label-for="price-rate"
              >
                <b-form-input
                  id="price-rate"
                  v-model="businessData.info.priceRate"
                  type="number"
                  placeholder="Enter Price Rate"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col
            v-if="isFoodBusinessType"
            md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="Maximum Items Per Order"
              rules="required"
            >
              <b-form-group
                label="Maximum Items Per Order"
                label-for="max-items-per-order"
              >
                <b-form-input
                  id="max-items-per-order"
                  v-model="businessData.info.maximumItemsPerOrder"
                  placeholder="Enter Maximum Items Per Order"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col
            v-if="isFoodBusinessType"
            md="8"
          />
          <b-col md="4">
            <b-button
              variant="primary"
              type="submit"
              :disabled="savingChanges"
            >
              <b-spinner
                v-if="savingChanges"
                small
              />
              <span v-else>Save changes</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </validation-observer>
  </b-form>
</template>

<script>
import {
  BCard,
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BRow,
  BCol,
  BSpinner,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import vSelect from 'vue-select'
import { required } from '@validations'
import { ref } from '@vue/composition-api'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import businessStore from '../store'
import { errorNotification, successNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BCard,
    BForm,
    BFormInput,
    BSpinner,
    ValidationProvider,
    BButton,
    ValidationObserver,
    BFormGroup,
    BRow,
    // vSelect,
    BCol,
  },
  props: {
    businessDetails: {
      type: Object,
      required: true,
    },
  },
  setup(props, ctx) {
    useRegisterStoreModule('business', businessStore)
    const formRef = ref(null)
    const savingChanges = ref(false)
    const businessData = ref({
      ...JSON.parse(JSON.stringify(props.businessDetails)),
      info: {
        preparationAvgTime: {
          en: props.businessDetails.info?.preparationAvgTime?.en || '',
          ar: props.businessDetails.info?.preparationAvgTime?.ar || '',
        },
        priceRate: props.businessDetails.info?.priceRate || 0,
        maximumItemsPerOrder: props.businessDetails.info?.maximumItemsPerOrder || 0,
      },
    })
    const isFoodBusinessType = props.businessDetails.businessTypes[0].logicalId === 'restaurant'

    const submit = async () => {
      const res = formRef.value.validate()
      if (!res) return
      if (isFoodBusinessType && (businessData.value.info.priceRate < 1 || businessData.value.info.priceRate > 4)) {
        errorNotification('Price rate must be between 1 and 4')
        return
      }
      try {
        savingChanges.value = true
        const PAYLOAD = {
          name: businessData.value.name,
          phoneNumber: businessData.value.phoneNumber,
          email: businessData.value.email,
        }

        if (isFoodBusinessType) {
          PAYLOAD.info = {
            preparationAvgTime: {
              en: businessData.value.info.preparationAvgTime.en,
              ar: businessData.value.info.preparationAvgTime.ar,
            },
            priceRate: +businessData.value.info.priceRate,
            maximumItemsPerOrder: +businessData.value.info.maximumItemsPerOrder,
          }
        }
        await ctx.root.$store.dispatch('business/updateBusiness', {
          businessId: props.businessDetails.id,
          data: PAYLOAD,
        })
        ctx.emit('updated')
        successNotification('Changes saved successfully')
      } catch (err) {
        errorNotification('Error..')
      } finally {
        savingChanges.value = false
      }
    }
    return {
      savingChanges,
      submit,
      isFoodBusinessType,
      formRef,
      required,
      businessData,
    }
  },
}
</script>

<style>

</style>
